import { io, Socket } from 'socket.io-client';
import { LocalStorageService } from './local-storage.service';

export const appUrl = process.env.REACT_APP_API_URL;

export class WebSocketService {
  private socket: Socket | null = null;
  private token: string | null = null;

  connect() {
    if (this.socket) {
      console.warn('WebSocket already connected');
      return;
    }

    const token = LocalStorageService.getToken();

    if (!token) {
      console.warn('Token not found');
      return;
    }

    const socketOptions = {
      transportOptions: {
        polling: {
          extraHeaders: {
            Authorization: `Bearer ${token.accessToken}`, // Передаем токен через заголовок
          },
        },
      },
      transports: ['polling', 'websocket'],
    };

    this.socket = io(appUrl + 'ws', socketOptions);

    this.socket.on('connect', () => {
      console.log('WebSocket connected');
    });

    this.socket.on('disconnect', () => {
      console.log('WebSocket disconnected');
    });

    this.socket.on('error', (error: string) => {
      console.error('WebSocket error:', error);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      console.log('WebSocket disconnected');
    }
  }

  on(event: string, callback: (data: any) => void) {
    if (!this.socket) {
      console.error('WebSocket is not connected');
      return;
    }

    this.socket.on(event, callback);
  }

  off(event: string, callback: (data: any) => void) {
    if (!this.socket) {
      console.error('WebSocket is not connected');
      return;
    }

    this.socket.off(event, callback);
  }

  emit(event: string, payload: any) {
    if (!this.socket) {
      console.error('WebSocket is not connected');
      return;
    }

    this.socket.emit(event, payload);
  }
}

export const webSocketService = new WebSocketService();
